
































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import {
  DefaultInvoicesFilters,
  InvoiceStatusFilter
} from "@/data/filters/invoice";

@Component({
  components: {
    "client-provider": () =>
      import("@/components/app/global/client/clientProvider.vue"),
    "client-well-link": () =>
      import("@/components/app/admin/clients/clientWellLink.vue"),
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue"),
    "products-table": () =>
      import("@/components/app/global/contractProducts/productsTable.vue"),
    "invoices-listing": () =>
      import("@/components/app/global/invoices/invoicesListing.vue"),
    "client-notes-component": () =>
      import("@/components/app/global/client/clientNotesComp.vue"),
    "client-secrets-component": () =>
      import("@/components/app/global/client/clientSecretsComp.vue")
  }
})
export default class ClientQuickLookModal extends Vue {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: "" })
  public clientIdentifier!: IClient["fullname"];

  public availableInvoiceFilters = () => [
    ...DefaultInvoicesFilters(),
    InvoiceStatusFilter()
  ];
}
